import { render } from "./BlogView.vue?vue&type=template&id=3a6eed0e"
import script from "./BlogView.vue?vue&type=script&lang=js"
export * from "./BlogView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__